module.exports = __webpack_public_path__ + "b6e02793d432515446ff757f429c5d8f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/walibi-holland-webfont.woff2
// module id = 32
// module chunks = 0